import React, { useEffect } from "react";
import bgImg from "../../assets/bg_img.jpg";

import arrowleft from "../../assets/back-arrow.svg";
import { Row, Col, Typography, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import "./cart.css";
import CartLoadCard from "../cardSample/CardSample";
import shirtImg from "../../assets/menShirt.jpg";
import { useAllProduct } from "../../components/api-context/commonApiContext";
import Config from "../../config/Config";

const { Title, Text } = Typography;

const CartPage = () => {
  const { merchantInfo, setMoneyLoadStatus } = useAllProduct();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!merchantInfo?.merchant_id) return;

    const fetchUserStatus = async () => {
      try {
        const response = await fetch(
          `${Config.node_api_endpoint}/get-user-status`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify({ payment_id: merchantInfo.payment_id }),
          }
        );
        const result = await response.json();
        if (result.success) {
          setMoneyLoadStatus(result.data.status);
        } else {
          console.warn("⚠️ Failed to fetch user:", result.message);
        }
      } catch (err) {
        console.error("❌ Error fetching user status:", err);
      }
    };

    fetchUserStatus();
  }, [merchantInfo, navigate]);

  const handleBack = () => {
    navigate("/kyc"); // go back to KYC or previous screen
  };

  const handleProceed = () => {
    navigate("/load-money"); // or /payment
  };

  const cartItem = {
    name: "Paisley Flora Shirt",
    size: "L",
    // price: 854,
    originalPrice: 1899,
    image: shirtImg,
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        height: "100vh",
        width: "100vw",
        position: "relative",
        color: "#fff",
        padding: "50px 20px 100px",
      }}
    >
      <Row
        justify="center"
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
        }}
      >
        <Col span={24}>
          {/* Header */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              marginBottom: 20,
              height: 40,
            }}
          >
            <img
              src={arrowleft}
              alt="Back"
              style={{
                cursor: "pointer",
                position: "absolute",
                left: 0,
              }}
              // onClick={handleBack}
            />
          </div>

          {/* Welcome Text */}

          {/* Cart Summary */}
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: "16px",
              // marginTop: 20,
              boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
            }}
          >
            <div className="mb-2">
              <Text
                style={{ color: "#fff", fontWeight: 700, fontSize: "18px" }}
              >
                <span style={{ color: "#333333" }}>Cart Summary</span>
              </Text>
            </div>
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <img
                src={cartItem.image}
                alt={cartItem.name}
                style={{
                  width: 70,
                  height: 70,
                  borderRadius: 8,
                  objectFit: "cover",
                }}
              />
              <div style={{ flex: 1 }}>
                <Text
                  style={{ color: "#000", fontWeight: 500, fontSize: 15 }}
                  ellipsis
                >
                  {cartItem.name}
                </Text>
                <div style={{ fontSize: 13, color: "#777" }}>
                  Size: {cartItem.size}
                </div>
                <div
                  style={{
                    marginTop: 4,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <span
                    style={{ fontWeight: 700, fontSize: 16, color: "#000" }}
                  >
                    ₹{merchantInfo.amount}
                  </span>
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "#999",
                      fontSize: 13,
                    }}
                  >
                    ₹{cartItem.originalPrice}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Khazana Card */}
          <div style={{ marginTop: 30 }}>
            <CartLoadCard />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CartPage;
